import React from "react";
import "./Footer.scss";
import { FaLocationArrow, FaMobileAlt, FaEnvelope } from "react-icons/fa";
import Payment from "../../assets/payments.png";
const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-content">
        <div className="col">
          <div className="title">About</div>
          <div className="text"><p>
            Welcome to our Pinch Harmonic Guitars, where we offer a wide range of guitars
            and accessories to meet the needs of every level of musician. Our
            shop has been providing quality instruments to guitar enthusiasts
            for years, and we take pride in the service and products we provide
            </p>
          </div>
        </div>
        <div className="col">
          <div className="title">Contact</div>
          <div className="c-item">
            <FaLocationArrow />
            <div className="text">
              Rock and Roll blvd, Nashville, Tennessee
            </div>
          </div>
          <div className="c-item">
            <FaMobileAlt />
            <div className="text">Phone: 555 01234</div>
          </div>
          <div className="c-item">
            <FaEnvelope />
            <div className="text">Email: store@phguitars.com</div>
          </div>
        </div>
        <div className="col">
          <div className="title">Categories</div>
          <span className="text">Fender</span>
          <span className="text">Gibson</span>
          <span className="text">PRS</span>
          <span className="text">Ibanez</span>
        </div>
        <div className="col">
          <div className="title">Pages</div>
          <span className="text">Home</span>
          <span className="text">Products</span>
          <span className="text">Privacy Policy</span>
          <span className="text">Returns</span>
          <span className="text">Terms & Conditions</span>
          <span className="text">Contact Us</span>
        </div>
      </div>
      <div className="bottom-bar">
        <div className="bottom-bar-content">
          <span className="text">
            PINCH HARMONIC GUITARS LTD 2023
          </span>
          <img src={Payment} />
        </div>
      </div>
    </div>
  );
};

export default Footer;
